export default __webpack_public_path__ + "static/rebecca-27ac6d83c31f5d36d19db47bf29021e6.png";